
/**
 * 预算编制 编辑
 * chenxiaojian 2020-02-14
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, TreeSelect, Select, Switch } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
//组织机构下来选择框
import orgUtil from '../../ui/orgUtil';

const fields = [{
    "text": "年份",
    "field": "year",
    disabled: true
}, {
    "text": "类型",
    "field": "type",
    "select": true,
    rules: [
        { required: true, message: '类型不能为空!' },
    ]
}, {
    "text": "所属部门",
    "field": "orgCode",
    "org": true,
    "type": 0,
    rules: [
        { required: true, message: '所属部门不能为空!' },
    ]
}, {
    "text": "预算编制人数",
    "field": "budgetStaff",
    "type": 0,
    "number": true,
    rules: [
        { required: true, message: '预算编制人数不能为空!' },
    ]
}, {
    "text": "预算外包人数",
    "field": "budgetEpiboly",
    "type": 0,
    "number": true,
    rules: [
        { required: true, message: '预算外包人数不能为空!' },
    ]
}, {
    "text": "现有编制人数",
    "field": "hasStaff",
    "type": 0,
    "number": true,
    rules: [
        { required: true, message: '现有编制人数不能为空!' },
    ]
}, {
    "text": "现有外包人数",
    "field": "hasEpiboly",
    "type": 0,
    "number": true,
    rules: [
        { required: true, message: '现有外包人数不能为空!' },
    ]

}, {
    "text": "上级项目",
    "field": "parentId",
    "type": 1,
    "parent": true,
    rules: [
        { required: true, message: '上级项目不能为空!' },
    ]
}, {
    "text": "项目名称",
    "field": "itemName",
    "type": 1,
    rules: [
        { required: true, message: '项目名称不能为空!' },
        { max: 32, message: '项目名称不能超过32个字符！' },
    ]
}, {
    "text": "上级项目",
    "field": "parentId",
    "type": 2,
    "parent": true,
    rules: [
        { required: true, message: '上级项目不能为空!' },
    ]
}, {
    "text": "项目名称",
    "field": "itemName",
    "type": 2,
    rules: [
        { required: true, message: '项目名称不能为空!' },
        { max: 32, message: '项目名称不能超过32个字符！' },
    ]
}, {
    "text": "上级项目",
    "field": "parentId",
    "type": 3,
    "parent": true,
    rules: [
        { required: true, message: '上级项目不能为空!' },
    ]
}, {
    "text": "项目名称",
    "field": "itemName",
    "type": 3,
    rules: [
        { required: true, message: '项目名称不能为空!' },
        { max: 32, message: '项目名称不能超过32个字符！' },
    ]
}, {
    "text": "业务指标只算金额",
    "field": "onlyMoney",
    "type": 1,
    "radio": true,
}, {
    "text": "年度数量指标",
    "field": "numBudget",
    "type": 1,
    "number": true,
    "onlyMoneyHide": true,
    rules: [
        { required: true, message: '年度数量指标不能为空!' },
    ]
}, {
    "text": "年度金额指标",
    "field": "moneyBudget",
    "type": 1,
    "number": true,
    rules: [
        { required: true, message: '年度金额指标不能为空!' },
    ]
}, {
    "text": "年度毛利指标",
    "field": "numBudget",
    "type": 3,
    "number": true,
    rules: [
        { required: true, message: '年度毛利指标不能为空!' },
    ]
}, {
    "text": "年度收入指标",
    "field": "moneyBudget",
    "type": 3,
    "number": true,
    rules: [
        { required: true, message: '年度收入指标不能为空!' },
    ]
}]

class YearBudgetEditForm extends Component {

    state = {
        orgList: [],
        firstOrg: '',
        type: null,    //默认初始化的时候是显示业务项目
    }

    componentDidMount() {
        orgUtil.findOrg(
            {},   //只查询市场会员的组织信息
            (res) => {
                this.setState({ orgList: res });
            }
        );
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id;
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["onlyMoney"] = values["onlyMoney"] ? 1 : 0;
            http.post({
                url: '/yearBudget/saveYearBudget',
                data: values,
                success: (res) => {
                    let queryData = this.props.queryData;
                    this.props.successCallback(queryData);
                    this.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    /**
     * 下拉框选择
     */
    selectChange = (value) => {
        this.setState({ type: value });
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        let type = this.state.type == null ? editData.type : this.state.type;
        let yearBudgetTree = null;
        if (this.props.yearBudgetData != null) {
            const temp = this.props.yearBudgetData();
            yearBudgetTree = temp.data;
        }
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            // eslint-disable-next-line eqeqeq
            if (item.type != null && item.type != type) {
                continue;
            }
            let onlyMoney = form.getFieldValue("onlyMoney");
            if(item.type === 1 && item.onlyMoneyHide && onlyMoney){
                continue;
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.radio ? editData[item.field] === 1 : editData[item.field] == null ? null : editData[item.field] + "",
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?
                                <InputNumber precision={item.precision == null ? 0 : item.precision} min={0.00} max={999999999} style={{ width: '100%' }} />
                                : item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} disabled={editData["id"] != null ? true : false} />
                                    : item.select ?
                                        <Select onChange={this.selectChange} allowClear={false}>
                                            <Select.Option key={0}>基本信息</Select.Option>
                                            <Select.Option key={1}>业务指标</Select.Option>
                                            <Select.Option key={2}>工作总结</Select.Option>
                                            <Select.Option key={3}>预算指标</Select.Option>
                                        </Select>
                                        : item.parent ? <TreeSelect treeData={yearBudgetTree} treeDefaultExpandAll={true} disabled={editData["id"] != null ? true : false} />
                                            : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" />
                                                : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    onCancel = () => {
        this.setState({ type: null });
        this.props.onCancel();
    }

    render() {
        const { visible } = this.props;
        return (
            <Modal
                width={520}
                visible={visible}
                title="年度计划信息维护"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={this.onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const YearBudgetEdit = Form.create()(YearBudgetEditForm);

export default YearBudgetEdit;